import React from 'react';

const ProductCard = ({ image, title, onClick, isSelected }) => {
  return (
    <div
      onClick={onClick}
      className={`
        relative h-fit w-full cursor-pointer overflow-hidden rounded-sm
        transition-all duration-300 hover:shadow-xl
        ${isSelected ? 'ring-2 ring-[#ED6B64]' : ''}
      `}
    >
      {/* Image Section */}
      <div className="relative aspect-square">
        <img
          src={image}
          alt={title}
          className="h-full w-full object-cover absolute inset-0"
        />
      </div>

      {/* Title Section */}
      <div className="flex  items-center justify-center border border-[#e0e0e0] bg-white">
        <span className="p-4 text-center text-[16px] font-bold text-black">
          {title}
        </span>
      </div>
    </div>
  );
};

export default ProductCard;
